import React, { useEffect } from 'react';
import { Form, Input, Typography } from 'antd';
import { TagOutlined } from '@ant-design/icons';

const { Text } = Typography;

const SetDatasetNameNodeProperties = ({ config, updateConfig }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      datasetName: config.datasetName || 'My Dataset',
    });
  }, [config, form]);

  const handleValuesChange = (changedValues, allValues) => {
    if (updateConfig) {
      updateConfig({
        config: allValues
      });
    }
  };

  return (
    <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
      <div style={{ marginBottom: 16, padding: '12px', background: '#e6f7ff', borderRadius: 4, border: '1px solid #91d5ff' }}>
        <Text type="secondary" style={{ fontSize: 12 }}>
          <TagOutlined /> Đặt tên cho tập dữ liệu (Dataset).
        </Text>
        <div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
          Node này giúp định danh dữ liệu (Dataset Name) để các node phía sau (như Join, Merge, Export Excel...) có thể nhận diện và sử dụng đúng tên này.
        </div>
      </div>

      <Form.Item 
        name="datasetName" 
        label="Dataset Name (Sheet Name)" 
        rules={[{ required: true, message: 'Please enter a name for this dataset' }]}
        help="Tên này sẽ được dùng làm tên Sheet trong file Excel"
      >
        <Input placeholder="e.g. Sales 2023" />
      </Form.Item>
    </Form>
  );
};

export default SetDatasetNameNodeProperties;